import React, { Component, useState } from 'react'
import { maxwidth, green, pink } from '../../constants'

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import axios from 'axios';
import './Salaamstree.css'
import { Checkbox } from '@mui/material';
import FillExample from './tab_bar';


export default function Salaamstree() {


    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [story, setStory] = useState('');
    const [check, setCheck] = useState(false);

    const handlesubmit = (e) => {
        e.preventDefault();
        
        
        const data = {
            Name: name,
            Phone: phone,
            Story: story
        }

        axios.post('https://sheet.best/api/sheets/62ccacd0-4a69-44aa-97e8-d5121285bfbd', data).then((response) => {
            
            
            setName('');
            setPhone('');
            setStory('');
            setCheck(false);

            myFunction();
        })
    }


    const myFunction = () => {

        var x = document.getElementById("snackbar");

        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 3000);
    }

   
    return (
       
        <div id='salaamstree' className='salaam-outer-container'>
            <p className='title'>Salaam Stree</p>
            <div className='salaam-inner-container'>
                <div className='salaam-subone' >
                    <FillExample></FillExample>
            
                </div>
                <div className='salaam-subtwo'>
                    <h3 style={{ fontSize: "30px", fontWeight: "bold", color: green }}>Share your Stories</h3>



                    <Form style={{ width: "100%", marginTop: "30px", gap: "20px", display: "flex", flexDirection: "column" }} onSubmit={handlesubmit}>

                        <Form.Control type="text" placeholder="Enter Name" onChange={(e) => setName(e.target.value)} value={name} required style={{ height: "50px" }} />

                        <Form.Control type="tel" pattern="[0-9]{10}" placeholder="Enter Phone Number" onChange={(e) => setPhone(e.target.value)} value={phone} required style={{ height: "50px" }} />


                        <Form.Control
                            as="textarea"
                            placeholder="Type your story here..."
                            style={{ height: '100px' }} onChange={(e) => setStory(e.target.value)} value={story}

                            required
                        />

                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <Checkbox type="checkbox" style={{ color: pink, padding: "0px" }} required onChange={(e)=> setCheck(e.target.checked)} checked={check} ></Checkbox>
                            <span style={{ paddingLeft: "10px", fontSize: "15px" }}>I 'd like to publish my story on STREE platform.
                            </span>
                        </div>



                        <Button variant="primary" type="submit" style={{ marginTop: "5px", borderRadius: "5px", backgroundColor: pink, borderColor: pink, height: "50px" }} >
                            Submit
                        </Button>


                        <div id="snackbar">Form Submitted Successfully!</div>
                    </Form>


                </div>
            </div>
        </div>
    )
}

